<div class="member-component">

  @for (memberFormGroup of memberFormGroups(); track memberFormGroup; let index = $index) {
    <div class="row separator-bottom">
      <div class="col-12">
        <div class="application-subsection-title">Member {{index + 1}}</div>
        <div class="mat-body">Minimum 1 member required</div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-3 col-md-12">
        <mat-button-toggle-group
          [hideSingleSelectionIndicator]="true"
          [hideMultipleSelectionIndicator]="true"
          [formControl]="memberFormGroupFormControl(memberFormGroup, 'type')">
          <mat-button-toggle value="Entity">Entity</mat-button-toggle>
          <mat-button-toggle value="Individual">Individual</mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    </div>
    <!-- INDIVIDUAL -->
    @if (memberFormGroupFormControl(memberFormGroup, 'type').value === 'Individual' &&
      memberFormGroupFormControl(memberFormGroup, 'individual')) {
      <div class="row">
        <div class="col-12">
          <individual-form
            [mark]="markObservable"
            [showAddressForm]="showAddressForm"
            [showIdentification]="showIdentification"
            [formControl]="memberFormGroupFormControl(memberFormGroup, 'individual')">
          </individual-form>
        </div>
      </div>
      <div class="row separator-bottom">
        <div class="col-12">
          <button mat-stroked-button color="warn" [disabled]="formArray.length <= 1" (click)="removeMember(memberFormGroup)">Remove Member</button>
        </div>
      </div>
      @if (showAssetsAndLiabilities) {
        <personal-assets
          [mark]="markObservable"
          (events)="onPersonalAssetEvent($event, memberFormGroup)"
        [formControl]="memberFormGroupFormControl(memberFormGroup, 'personalAssets')"></personal-assets>
      }
      @if (showAssetsAndLiabilities) {
        <personal-liabilities
          [mark]="markObservable"
          (events)="onPersonalLiabilitiesEvent($event, memberFormGroup)"
        [formControl]="memberFormGroupFormControl(memberFormGroup, 'personalLiabilities')"></personal-liabilities>
      }
    }
    <!-- ENTITY -->
    @if (memberFormGroupFormControl(memberFormGroup, 'type').value === 'Entity' &&
      memberFormGroupFormControl(memberFormGroup, 'organisation')) {
      <div class="row">
        <div class="col-lg-6 col-md-12">
          <business-number-search
            [mark]="markObservable"
            [searchFn]="businessNumberSearchFn"
          [formControl]="memberFormGroupFormControl(memberFormGroup, 'organisation')"></business-number-search>
        </div>
        <div class="col-lg-3 col-md-12">
          <entity-type
            [readonly]="entityTypeReadonly"
            [mark]="markObservable"
            [formControl]="memberFormGroupFormControl(memberFormGroup, 'organisationType')">
          </entity-type>
        </div>
      </div>
      <div class="row separator-bottom">
        <div class="col-12">
          <button mat-stroked-button color="warn" [disabled]="formArray.length <= 1" (click)="removeMember(memberFormGroup)">Remove Member</button>
        </div>
      </div>
    }
    <div class="row separator-bottom">
      <div class="col-12">
        <button mat-stroked-button (click)="addMember()">
          <span class="mdi mdi-plus" matPrefix></span>
          Add Member
        </button>
      </div>
    </div>
  }

</div>
